import React from 'react';
import { Grid } from '@mui/material';
import { Customer } from '../../../models/customer.model';
import CustomerContactCard from '../../../common/customer-contact-card/CustomerContactCard';

interface ContactsTabsProps {
  customer?: Customer;
  companyId: number;
  key: string;
}

const ContactsTabs: React.FC<ContactsTabsProps> = ({ customer, companyId }) => {
  const contacts = customer?.contacts || [];

  return (
    <>
      <Grid container wrap='wrap' rowGap={2}>
        <Grid size={{ xs: 12 }} container spacing={2} direction='column'>
          {contacts.length > 0 &&
            contacts.map((contact) => (
              <Grid key={contact.id}>
                <CustomerContactCard contact={contact} companyId={companyId} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default ContactsTabs;
